export const copyToClipboard = async (shareUrl) => {
  try {
    await navigator.clipboard.writeText(shareUrl);
    console.log("Link kopyalandı: " + shareUrl);
  } catch (error) {
    console.error("Kopyalama başarısız: ", error);
  }
};
